import React from 'react';
import { CompositeDecorator, EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';

import { Block, Entity, Inline } from '../components/forms/editorComponents/util/constants';

const styles = {
  root: {
    fontFamily: '\'Georgia\', serif'
    , padding: 20
    , width: 600
  },
  buttons: {
    marginBottom: 10
  },
  urlInputContainer: {
    marginBottom: 10
  },
  urlInput: {
    fontFamily: '\'Georgia\', serif'
    , marginRight: 10
    , padding: 3
    , width: '30%'
  },
  editor: {
    border: '1px solid #ccc'
    , cursor: 'text'
    , minHeight: 80
    , padding: 10
  },
  button: {
    marginTop: 10
    , textAlign: 'center'
  },
  link: {
    color: '#3b5998'
    , textDecoration: 'underline'
  },
};

const richContentUtils = {

  editorState(content) {
    // render Draft content
    let rawContent = Object.assign({}, content);
    if(!rawContent.entityMap) {
      rawContent.entityMap = {};
    }
    const Link = (props) => {
      const {url} = props.contentState.getEntity(props.entityKey).getData();
      return (
        <a href={url} style={styles.link}>
          {props.children}
        </a>
      );
    };
    const decorator = new CompositeDecorator([
      {
        strategy: richContentUtils._findLinkEntities
        , component: Link
      }
    ]);
    let currentContent = EditorState.createWithContent(convertFromRaw(rawContent), decorator).getCurrentContent();
    return this._renderHTML(currentContent);
  }

  , _findLinkEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(
      (character) => {
        const entityKey = character.getEntity();
        return (
          entityKey !== null &&
          contentState.getEntity(entityKey).getType() === 'LINK'
        );
      },
      callback
    );
  }

  // converting to HTML functions
  , _renderHTML(contentState) {
    return convertToHTML({
      styleToHTML: (style) => {
        switch (style) {
          case Inline.ITALIC:
            return <em className={`md-inline-${style.toLowerCase()}`} />;
          case Inline.BOLD:
            return <strong className={`md-inline-${style.toLowerCase()}`} />;
          case Inline.STRIKETHROUGH:
            return <strike className={`md-inline-${style.toLowerCase()}`} />;
          case Inline.UNDERLINE:
            return <u className={`md-inline-${style.toLowerCase()}`} />;
          case Inline.HIGHLIGHT:
            return <span className={`md-inline-${style.toLowerCase()}`} />;
          case Inline.CODE:
            return <code className={`md-inline-${style.toLowerCase()}`} />;
          default:
            return null;
        }
      }
      , blockToHTML: (block) => {
        const blockType = block.type;
        switch (blockType) {
          case Block.H1:
            // eslint-disable-next-line jsx-a11y/heading-has-content
            return <h1 className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.H2:
            // eslint-disable-next-line jsx-a11y/heading-has-content
            return <h2 className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.H3:
            // eslint-disable-next-line jsx-a11y/heading-has-content
            return <h3 className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.H4:
            // eslint-disable-next-line jsx-a11y/heading-has-content
            return <h4 className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.H5:
            // eslint-disable-next-line jsx-a11y/heading-has-content
            return <h5 className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.H6:
            // eslint-disable-next-line jsx-a11y/heading-has-content
            return <h6 className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.BLOCKQUOTE_CAPTION:
          case Block.CAPTION:
            return {
              start: `<p class="md-block-${blockType.toLowerCase()}"><caption>`,
              end: '</caption></p>',
            };
          case Block.IMAGE: {
            const imgData = block.data;
            const text = block.text;
            const extraClass = (text.length > 0 ? ' md-block-image-has-caption' : '');
            return {
              start: `<figure class="md-block-image${extraClass}"><img src="${imgData.src}" alt="${block.text}" /><figcaption className="md-block-image-caption">`,
              end: '</figcaption></figure>',
            };
          }
          case Block.ATOMIC:
            return {
              start: `<figure className="md-block-${blockType.toLowerCase()}">`,
              end: '</figure>',
            };
          case Block.TODO: {
            const checked = block.data.checked || false;
            let inp = '';
            let containerClass = '';
            if (checked) {
              inp = '<input type=checkbox disabled checked="checked" />';
              containerClass = 'md-block-todo-checked';
            } else {
              inp = '<input type=checkbox disabled />';
              containerClass = 'md-block-todo-unchecked';
            }
            return {
              start: `<div class="md-block-${blockType.toLowerCase()} ${containerClass}">${inp}<p>`,
              end: '</p></div>',
            };
          }
          case Block.BREAK:
            return <hr className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.BLOCKQUOTE:
            return <blockquote className={`md-block-${blockType.toLowerCase()}`} />;
          case Block.OL:
            return {
              element: <li />,
              nest: <ol className={`md-block-${blockType.toLowerCase()}`} />,
            };
          case Block.UL:
            return {
              element: <li />,
              nest: <ul className={`md-block-${blockType.toLowerCase()}`} />,
            };
          case Block.UNSTYLED:
            if (block.text.length < 1) {
              return <p className={`md-block-${blockType.toLowerCase()}`}><br /></p>;
            }
            return <p className={`md-block-${blockType.toLowerCase()}`} />;
          default: return null;
        }
      }
      , entityToHTML: (entity, originalText) => {
        if (entity.type === Entity.LINK) {
          return (
            <a
              className="md-inline-link"
              href={entity.data.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {originalText}
            </a>
          );
        }
        if (entity.type === 'image' || entity.type === 'IMAGE') {
          return `<img src='${entity.data.src}' />`;
        }
        return originalText;
      }
    })(contentState);
  }

}

export default richContentUtils;



// WEBPACK FOOTER //
// global/utils/richContentUtils.js